export const CREATE_DEVICE_GROUP = "CREATE_DEVICE_GROUP";
export const GET_ALL_DEVICE_GROUP = "GET_ALL_DEVICE_GROUP";
export const UPDATE_DEVICE_GROUP = "UPDATE_DEVICE_GROUP";
export const DELETE_DEVICE_GROUP = "DELETE_DEVICE_GROUP";
